import { Truck } from "lucide-react";
import { useLang } from "@/context/LanguageContext";

export const AnnouncementBar = () => {
    const { t } = useLang();
    return (
        <div
            data-testid="announcement-bar"
            className="bg-bordeaux text-white py-2.5 px-4 text-center"
        >
            <span className="inline-flex items-center justify-center gap-2">
                <Truck className="h-4 w-4 shrink-0" strokeWidth={2.4} />
                <span className="relative flex h-2 w-2 shrink-0" aria-hidden="true">
                    <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75"></span>
                    <span className="relative inline-flex h-2 w-2 rounded-full bg-green-400"></span>
                </span>
                <span className="text-xs sm:text-sm font-extrabold uppercase tracking-[0.12em]">
                    {t("announcementStrong")}
                </span>
                <span className="text-[11px] sm:text-xs font-medium opacity-90">
                    · {t("announcementRest")}
                </span>
            </span>
        </div>
    );
};
